import React, { useState, useEffect } from "react";
import { Stack, TextField, MenuItem, Box, IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";

interface PayoutSearchFormProps {
    currencyOptions: string[];
    search: (values: any, refresh: boolean) => void;
    defaultValues?: { from: string; to: string; currency: string[] };
}

export const PayoutSearchForm = ({ currencyOptions, search, defaultValues }: PayoutSearchFormProps) => {

    const [values, setValues] = useState({
        from: defaultValues?.from || "",
        to: defaultValues?.to || "",
        currency: defaultValues?.currency?.[0] || "ALL"
    });

    useEffect(() => {
        if (defaultValues) {
            setValues({
                from: defaultValues.from || "",
                to: defaultValues.to || "",
                currency: defaultValues.currency?.[0] || "ALL"
            });
        }
    }, [defaultValues]);

    const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setValues(prev => ({ ...prev, [field]: event.target.value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        search({
            from: values.from,
            to: values.to,
            currency: [values.currency]
        }, false);
    };

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} alignItems="flex-end">
                <TextField
                    label="From Date"
                    type="date"
                    value={values.from}
                    onChange={handleChange('from')}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    required
                />

                <TextField
                    label="To Date"
                    type="date"
                    value={values.to}
                    onChange={handleChange('to')}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    required
                />

                <TextField
                    select
                    label="Currency"
                    value={values.currency}
                    onChange={handleChange('currency')}
                    fullWidth
                >
                    {currencyOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </TextField>

                <Stack direction="row" spacing={1} sx={{ minWidth: 'fit-content' }}>
                    <IconButton
                        type="submit"
                        sx={{
                            height: 56,
                            width: 56,
                            bgcolor: '#1976d2',
                            color: '#fff',
                            borderRadius: 2,
                            '&:hover': { bgcolor: '#195ad2' }
                        }}
                    >
                        <Search />
                    </IconButton>
                </Stack>
            </Stack>
        </Box>
    );
};